import { loader } from 'graphql.macro'

export default async function enableDisableTermsAndCondition ({ dataLoaders, variables }) {
  const schema = loader('./enableDisableTermsAndCondition.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      id: variables.id,
      isEnabled: variables.isEnabled
    }
  })
  return response.enableDisableTermsAndCondition
}
